import { useQuery } from "@tanstack/react-query";
import React from "react";
import { BiMenu } from "react-icons/bi";
import { Link, NavLink } from "react-router-dom";
import { BASE_URL, IMAGE_BASE_URL } from "../data/baseURL";
import { navbarData } from "../data/fakeData";

const Navbar = () => {
  const { data } = useQuery(["navbar"], async () => {
    const response = await window.fetch(`${BASE_URL}/theme`);
    return await response.json();
  });

  return (
    <nav className="navbar navbar-expand-lg py-4">
      <div className="container-fluid mx-7">
        <Link className="navbar-brand fs-28 text-white" to="/">
          <img
            src={`${IMAGE_BASE_URL}/${data?.theme?.theme_logo?.header_logo}`}
            alt=""
            className="img-fluid"
          />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="true"
          aria-label="Toggle navigation"
        >
          <span>
            <BiMenu className="text-white" size={24} />
          </span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav nav-background ms-auto mb-2 mb-lg-0 fs-20 pt-5 pt-lg-0 ">
            {navbarData.map((data, index) => (
              <li
                className={`nav-item navbar-mx-5 pt-2 ${
                  data?.hasDropDown && "dropdown"
                }`}
                key={index}
              >
                {data?.nestedRoutes ? (
                  <DropDownMenu
                    routes={data?.nestedRoutes}
                    label={data?.name}
                  />
                ) : (
                  <NavLink
                    className={({ isActive }) =>
                      isActive
                        ? "navbar-active nav-link text-white d-inline-block"
                        : "nav-link text-white d-inline-block"
                    }
                    to={`${data?.path}`}
                  >
                    {`${data?.name}`}
                  </NavLink>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

function DropDownMenu({ routes, label }) {
  return (
    <>
      <p
        className="nav-link dropdown-toggle text-white"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {label}
      </p>
      <ul className="dropdown-menu bg-dark  text-white">
        {routes?.map((route) => (
          <li key={route?.label} className="text-white fs-16">
            <NavLink to={route?.link} className="dropdown-item text-white py-2">
              {route?.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </>
  );
}

export default Navbar;
